// OverlayPanelContent.tsx
import React, { useState } from 'react';
import profile_mtp from '../assets/images/profile/no_image.jpg';
import { ProfileDetailsShowView, ProfileLockUnlockMethod } from '../helpers/submitDataOnServer';
import { ToastWarning } from './Toast';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
interface UserProps {
    memberSN: number;
    name: string;
    tole: string | null;
    phone: string;
    address: string;
    fatherName: string;
    photo: string;
    lock_unlock: number | null;
    lock_status: number;
    refetch: () => void;
}

const OverlayPanelContent: React.FC<UserProps> = ({
    memberSN,
    name,
    tole,
    phone,
    address, refetch,
    fatherName, photo, lock_unlock, lock_status
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [onPassoword, setOnPassword] = useState("");
    const profileLockUnlock = async () => {
        await ProfileLockUnlockMethod(memberSN, onPassoword, refetch);
        setOnPassword("");
    }
    const singleProfileShow = async () => {
        await ProfileDetailsShowView(memberSN, onPassoword, navigate, dispatch);
    }
    const password_requireed = async () => {
        await ToastWarning({ message: "Enter Your Password" })
    }
    return (
        <div className='flex flex-row gap-3'>
            <div className='space-y-3'>
                <div className='space-y-0.5'>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Member SN:</span>
                        <span className='font-normal text-gray-500'> {memberSN}</span>
                    </h1>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Name:</span>
                        <span className='font-normal text-gray-500'> {name}</span>
                    </h1>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Tole/Marga:</span>
                        <span className='font-normal text-gray-500'> {tole}</span>
                    </h1>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Phone No.:</span>
                        <span className='font-normal text-gray-500'> {phone}</span>
                    </h1>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Address:</span>
                        <span className='font-normal text-gray-500'> {address}</span>
                    </h1>
                    <h1 className='text-[12px]'>
                        <span className='font-medium text-sky-900'>Father Name:</span>
                        <span className='font-normal text-gray-500'> {fatherName}</span>
                    </h1>
                </div>
                {
                    lock_unlock === memberSN && <div className='gap-2 mt-4'>
                        <input
                            type="password"
                            placeholder='Password' onChange={(e) => setOnPassword(e.target.value)}
                            className='w-28 ring-[1px] px-1 text-[12px] py-0.5 rounded-sm placeholder:text-[12px] ring-gray-200 focus:outline-none focus:ring-[1px] focus:ring-green-500'
                        />
                        <button onClick={profileLockUnlock} className='px-2 bg-green-500 text-white h-6 rounded-sm text-[10px] ml-2'>{lock_status === 1 ? "Unlock" : "Lock"}</button>
                    </div>
                }
                {
                    lock_unlock === null && lock_status === 1 && <div className='gap-2 mt-4'>
                        <input
                            type="password"
                            placeholder='Password' onChange={(e) => setOnPassword(e.target.value)}
                            className='w-28 ring-[1px] px-1 text-[12px] py-0.5 rounded-sm placeholder:text-[12px] ring-gray-200 focus:outline-none focus:ring-[1px] focus:ring-green-500'
                        />
                        <button
                            onClick={() => {
                                onPassoword ? singleProfileShow() : password_requireed();
                            }}
                            className='px-2 bg-green-500 text-white h-6 rounded-sm text-[10px] ml-2'
                        >
                            Profile
                        </button>
                    </div>
                }
                {
                    lock_status === 0 && lock_unlock === null && <div className='gap-2 mt-4'>
                        <Link to={`/front/office/profile/details/view/${memberSN}`}>
                            <button onClick={singleProfileShow} className='px-3 bg-green-500 text-white h-6 rounded-sm text-[10px]'>See Profile</button>
                        </Link>
                    </div>
                }
            </div>
            <div>
                <img src={photo ? photo : profile_mtp} alt="" className="h-30 w-16 border-[1px] border-gray-400 rounded-sm" />
            </div>
        </div>
    );
}

export default OverlayPanelContent;
